import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Container, Row } from "reactstrap";
import DataReactTable from "@/containers/Tables/DataTable/components/DataReactTable";
import AddModal from "@/shared/components/AddModal";
import Modal from "@/shared/components/Modal";
import {
  useLazyGetRecordsQuery,
  useDeleteMutation,
} from "@/services/SignPunsApi";
import { PUN_CATEGORY_TAG } from "@/shared/tagFile";
import { successToast } from "@/shared/components/toast";
import { formateColumnFilter } from "@/utils/columnFilter";
import { getAllPunCategory } from "../../SignSlice";
import PunsCategoryForm from "./PunsCategoryForm";
import "react-toastify/dist/ReactToastify.css";

const PunsCategory = () => {
  const [punCategoryDetails, setPunCategoryDetails] = useState();
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState();
  const [deletePunCategory, { isLoading: isDeleting }] = useDeleteMutation();
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState([]);
  const [globalSearchKeyword, setGlobalSearchKeyword] = useState(null);
  const [columnFilter, setColumnFilter] = useState({});
  const dispatch = useDispatch();
  const [
    getPunCategoryRecords,
    {
      data: punCategoryList,
      isError: isPunCategoryError,
      isLoading: isPunCategoryLoading,
      isFetching: isPunCategoryFetching,
    },
  ] = useLazyGetRecordsQuery();

  const column = [
    {
      Header: "#",
      accessor: "Id",
      type: "Number",
    },
    {
      Header: "Pun Line 1",
      accessor: "Pun.Line1",
      filter: true,
      Cell: ({ value }) => {
        return value ? value : "-";
      },
    },
    {
      Header: "Category Name",
      accessor: "Category.Name",
      filter: true,
      Cell: ({ value }) => {
        return value ? value : "-";
      },
    },
  ];

  const handleEditData = (PunCategoryData) => {
    setSelectedRecord(PunCategoryData);
    setIsAddModalOpen(true);
  };

  const handleDelete = () => {
    deletePunCategory({
      entity: "PunCategory",
      id: selectedRecord.Id,
      tag: PUN_CATEGORY_TAG,
    }).then((response) => {
      if (!response.error) {
        !isDeleting && setIsDeleteModalOpen(!isDeleteModalOpen);
        successToast("Pun Category deleted successfully.");
      }
    });
  };

  useEffect(() => {
    let { filterColumn, filterQuery } = formateColumnFilter(
      column,
      columnFilter
    );

    getPunCategoryRecords({
      entity: "PunCategory",
      expand: { Pun: {}, Category: {} },
      top: pageSize,
      skip: (page - 1) * pageSize,
      sort: sort,
      filter: filterQuery,
      globalFilter: {
        columns: filterColumn,
        globalSearchKeyword: globalSearchKeyword,
      },
      tag: PUN_CATEGORY_TAG,
    });
    setPunCategoryDetails({ tableHeaderData: column, tableRowsData: [] });
    // eslint-disable-next-line
  }, [pageSize, page, sort, globalSearchKeyword, columnFilter]);

  useEffect(() => {
    if (
      !isPunCategoryLoading &&
      !isPunCategoryError &&
      punCategoryList &&
      !isPunCategoryFetching
    ) {
      dispatch(getAllPunCategory(punCategoryList.value));
      let PunCategoryData = [...punCategoryList.value];
      setPunCategoryDetails({
        ...punCategoryDetails,
        tableRowsData: punCategoryList.value ? PunCategoryData : [],
        totalData:
          punCategoryList && punCategoryList["@odata.count"]
            ? punCategoryList["@odata.count"]
            : 0,
        onEditClick: (data) => handleEditData(data),
        onDeleteClick: (data) => {
          setIsDeleteModalOpen(true);
          setSelectedRecord(data);
        },
      });
    }
    // eslint-disable-next-line
  }, [
    isPunCategoryError,
    punCategoryList,
    isPunCategoryLoading,
    isPunCategoryFetching,
  ]);

  return (
    <Container>
      <Row>
        {punCategoryDetails && (
          <DataReactTable
            reactTableData={punCategoryDetails}
            onAddClick={() => {
              setIsAddModalOpen(true);
              setSelectedRecord();
            }}
            title="Pun Category"
            isFetching={isPunCategoryFetching}
            setPageNumber={setPage}
            recordsPerPage={pageSize}
            setRecordsPerPage={setPageSize}
            setSort={setSort}
            setGlobalSearchKeyword={setGlobalSearchKeyword}
            setColumnFilter={setColumnFilter}
          />
        )}
      </Row>
      {isAddModalOpen && (
        <AddModal
          toggle={() => setIsAddModalOpen(!isAddModalOpen)}
          color="success"
          title={`${selectedRecord ? "Edit" : "Add"} Pun Category`}
          header
          btn="Success"
          message={
            <PunsCategoryForm
              editData={selectedRecord ? selectedRecord : {}}
              setIsAddModalOpen={setIsAddModalOpen}
            />
          }
        />
      )}
      {isDeleteModalOpen && (
        <Modal
          color="danger"
          title="Delete"
          message={`Are you sure you want to delete ${selectedRecord.Pun.Line1}?`}
          handleOkClick={() => handleDelete()}
          toggle={() => setIsDeleteModalOpen(!isDeleteModalOpen)}
          isDeleting={isDeleting}
        />
      )}
    </Container>
  );
};

export default PunsCategory;
